var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c('block-tiles',{attrs:{"block":_vm.block,"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('pricing-tile',{attrs:{"item":item,"config":_vm.block.config,"block":_vm.block,"course":_vm.course}})]}}],null,false,3497330094)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }